/**
 * Request Queue
 * Queues requests during token refresh to avoid multiple concurrent refresh attempts
 */ let isRefreshing = false;
let requestQueue = [];
/**
 * Check if a token refresh is currently in progress
 */ export function isRefreshInProgress() {
    return isRefreshing;
}
/**
 * Set the refresh state
 */ export function setRefreshInProgress(value) {
    isRefreshing = value;
}
/**
 * Add a request to the queue (to be retried after refresh completes)
 */ export function queueRequest(url, init, resolve, reject) {
    requestQueue.push({
        url,
        init,
        resolve,
        reject
    });
}
/**
 * Process all queued requests after successful token refresh
 * Retries each request and resolves/rejects the original promises
 */ export async function processQueue(fetchFn) {
    const queue = [
        ...requestQueue
    ];
    requestQueue = [];
    for (const { url, init, resolve, reject } of queue){
        try {
            const response = await fetchFn(url, init);
            resolve(response);
        } catch (error) {
            reject(error instanceof Error ? error : new Error(String(error)));
        }
    }
}
/**
 * Reject all queued requests (called when refresh fails)
 */ export function rejectQueue(error) {
    const queue = [
        ...requestQueue
    ];
    requestQueue = [];
    for (const { reject } of queue){
        reject(error);
    }
}
/**
 * Clear the queue and reject any pending promises (used for cleanup/logout)
 */ export function clearQueue() {
    rejectQueue(new Error('Auth state cleared'));
    isRefreshing = false;
}
